import { render, staticRenderFns } from "./CardDialog.vue?vue&type=template&id=284af6a8&scoped=true&"
import script from "./CardDialog.vue?vue&type=script&lang=js&"
export * from "./CardDialog.vue?vue&type=script&lang=js&"
import style0 from "./CardDialog.vue?vue&type=style&index=0&id=284af6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284af6a8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284af6a8')) {
      api.createRecord('284af6a8', component.options)
    } else {
      api.reload('284af6a8', component.options)
    }
    module.hot.accept("./CardDialog.vue?vue&type=template&id=284af6a8&scoped=true&", function () {
      api.rerender('284af6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardDialog.vue"
export default component.exports